import { systemLib } from 'shared';

// оптимальный отступ для статус бара на андройде
const DEFAULT_STATUS_BAR_HEIGHT = '48';
const STATUS_BAR_HEIGHT_VAR = '--status-bar-height';
const STORAGE_KEY = 'statusBarHeight';
// вырубаем отступы на дестктопе в дев моде для better dev experience
const IS_DEV_MODE = import.meta.env.VITE_RUNTIME_ENV === 'development';

// Устанавливает CSS переменную на корневом элементе.
const applyStatusBarHeight = (height: number | string) => {
  document.documentElement.style.setProperty(
    STATUS_BAR_HEIGHT_VAR,
    `${height}px`,
  );
};

export function getStatusBarHeight() {
  return parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue(STATUS_BAR_HEIGHT_VAR)
      .trim(),
  );
}

// Берем значение переменной --safe-area-top которую записываем в /packages/freedom-css/index.css
const getSafeAreaInsetTop = (): Promise<number> => {
  return new Promise(resolve => {
    for (let i = 0; i < 13; i++) {
      setTimeout(() => {
        const value = getComputedStyle(document.documentElement)
          .getPropertyValue('--safe-area-top')
          .trim();

        const parsed = parseInt(value, 10);
        if (parsed > 0) {
          resolve(parsed);
        }
      }, 2 ** i);
    }
  });
};

// Основная функция. Определяет OS, проверяет кэш, запускает измерение, сохраняет результат.
export const setStatusBarHeight = async () => {
  const clientOS = systemLib.getMobileOperatingSystem();

  if (IS_DEV_MODE) {
    applyStatusBarHeight(0);
    return;
  }

  applyStatusBarHeight(DEFAULT_STATUS_BAR_HEIGHT);

  if (clientOS !== 'ios') return;

  const savedHeight = localStorage.getItem(STORAGE_KEY);
  if (savedHeight) {
    applyStatusBarHeight(savedHeight);
    return;
  }

  const computedHeight = await getSafeAreaInsetTop();
  if (computedHeight > 0) {
    localStorage.setItem(STORAGE_KEY, computedHeight?.toString());
    applyStatusBarHeight(computedHeight);
  }
};
